import React, { Component } from 'react';
import { firestoreConnect } from 'react-redux-firebase';
import FileUploader from 'react-firebase-file-uploader';
import firebase from 'firebase';

import Header from './Header';

class AssetAdd extends Component {
  state = {
    name: '',
    desc: '',
    preview: '',
    downloadLink: '',
    added: new Date(),
    username: '',
    avatar: '',
    isUploading: false,
    progress: 0,
    avatarURL: '',
  };

  onChange = e => this.setState({ [e.target.name]: e.target.value });
  onSubmit = e => {
    e.preventDefault();
    const newAsset = this.state;
    const { firestore, history } = this.props;
    firestore.add({ collection: 'assets' }, newAsset).then(() => history.push('/members'));
  };
  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
  handleProgress = progress => this.setState({ progress });
  handleUploadError = error => {
    this.setState({ isUploading: false });
    console.error(error);
  };
  handleUploadSuccess = filename => {
    this.setState({ avatar: filename, progress: 100, isUploading: false });
    firebase
      .storage()
      .ref('images')
      .child(filename)
      .getDownloadURL()
      .then(url => this.setState({ downloadLink: url }));
  };

  render() {
    return (
      <div>
        <Header title="Dodaj novi asset" img="/images/gallery/2013/074.jpg" />
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <form onSubmit={this.onSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      {/* <label htmlFor="name">Naziv</label> */}
                      <input
                        type="text"
                        className="form-control u-rounded-50 p-3 u-mb-30"
                        name="name"
                        placeholder="Naziv"
                        required
                        value={this.state.name}
                        onChange={this.onChange}
                      />
                    </div>
                    {/* <label htmlFor="name">Opis</label> */}
                    <div className="col-md-12">
                      <input
                        type="text"
                        className="form-control u-rounded-50 p-3 u-mb-30"
                        name="desc"
                        placeholder="Opis"
                        required
                        value={this.state.desc}
                        onChange={this.onChange}
                      />
                    </div>
                    {/* <label htmlFor="name">Preview</label> */}
                    <div className="col-md-12">
                      <input
                        type="text"
                        className="form-control u-rounded-50 p-3 u-mb-30"
                        name="preview"
                        placeholder="Preview"
                        required
                        value={this.state.preview}
                        onChange={this.onChange}
                      />
                    </div>
                    {/* <label htmlFor="name">Download Link</label> */}
                    <div className="col-md-12">
                      <input
                        type="text"
                        className="form-control u-rounded-50 p-3 u-mb-30"
                        name="downloadLink"
                        placeholder="Download Link"
                        required
                        value={this.state.downloadLink}
                        onChange={this.onChange}
                      />
                    </div>
                    <div className="col-md-12">
                      {/* <input
                        type="text"
                        value={this.state.username}
                        name="username"
                        onChange={this.handleChangeUsername}
                      />
                      <label>Avatar:</label> */}
                      {this.state.isUploading && <p>Progress: {this.state.progress}%</p>}
                      {this.state.downloadLink && <img src={this.state.downloadLink} width={300} alt="" />}
                      <label
                        style={{
                          backgroundColor: 'steelblue',
                          color: 'white',
                          padding: 10,
                          borderRadius: 4,
                          pointer: 'cursor',
                        }}
                      >
                        Select your awesome avatar
                        <FileUploader
                          accept="image/*"
                          name="avatar"
                          randomizeFilename
                          storageRef={firebase.storage().ref('images')}
                          onUploadStart={this.handleUploadStart}
                          onUploadError={this.handleUploadError}
                          onUploadSuccess={this.handleUploadSuccess}
                          onProgress={this.handleProgress}
                        />
                      </label>
                    </div>
                  </div>
                  <button className="btn btn-rounded btn-primary" type="submit">
                    DODAJ NOVI ASSET
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default firestoreConnect()(AssetAdd);



// WEBPACK FOOTER //
// ./src/components/AssetAdd.js